import React from 'react';

interface Props {
    remark: string;
    enabled: boolean;
    classNameS?: string;
}

export default function DeatilRemark({ remark, enabled = true, classNameS }: Props) {
    return (
        (enabled && (
            <div
                className={`text-[#333] text-[11px] font-normal bg-[#f4f4f4] px-[16px] ${classNameS}`}
            >
                {remark}
            </div>
        )) || <></>
    );
}
